import React from "react";
import PropTypes from "prop-types";

const OClientCard = ({ clientName, clientNameFormer, slug, htmlDescription, gradientTo, gradientFrom }) => {
    const gradientStyle = {
        backgroundImage: `linear-gradient(to bottom, ${gradientFrom}, ${gradientTo}`,
        backgroundColor: `${gradientFrom}`
    };

    return (
        <div className="relative flex flex-column justify-center items-center pv6 min-vh-100">
            <div className="ph3 ph5-xs ph0-l w-70-l z-1">
                <div className="flex flex-column flex-row-ns">
                    <div className={`w-40-ns`}>
                        <div
                            className={`h4 mheight-4 bg-image-${slug} contain bg-center bg-top-ns mt1 mb2 mb0-ns mh4 mh0-ns`}
                        />
                    </div>
                    <div className="w-60-ns pt3 pt0-ns pr5-ns">
                        <div className="fira f3 lh-title">
                            <h3 className="f2-ns fw5 ma0 lh-title mb3">{clientName}</h3>
                            {clientNameFormer && (
                                <div className="pt1 lh-copy lato cms fw4 f5 f4-ns o-50 mb3">{clientNameFormer}</div>
                            )}
                        </div>
                        <div
                            className="lh-copy lato cms fw4 f5 f4-ns measure-wide"
                            dangerouslySetInnerHTML={{ __html: htmlDescription }}
                        />
                    </div>
                </div>
            </div>
            <div style={gradientStyle} className={`absolute absolute--fill wch-t z0 ma0`} />
        </div>
    );
};

export default OClientCard;

OClientCard.propTypes = {
    clientName: PropTypes.string,
    clientNameFormer: PropTypes.string,
    slug: PropTypes.string,
    htmlDescription: PropTypes.string,
    gradientTo: PropTypes.string,
    gradientFrom: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/OClientCard.js